import MessageIcon from '@mui/icons-material/Message';
import { IconButton } from "@mui/material";
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import {nextPreload} from '@fanfanlo'
export function IMOpenPageLink(){
    const router = useRouter();
    
  useEffect(() => {
    nextPreload(router, '/im');
  }, []);
    function onClick(){
        router.push('/im')
    }
    return (
        <span>
            <IconButton onClick={onClick}>
                <MessageIcon />
                {/* {t('PageLinks.im')} */}
            </IconButton>
        </span>
    )
}